import {
  getData,
  postData
} from './api-base.service'

export const destoryGPSViewProperty = (obj) => {
  let retObj = $.extend(true, {}, obj);

  if (retObj.Value == undefined) {
    $.extend(retObj, {
      Value: retObj.ValueView != 0 ? 1 / retObj.ValueView : 0
    });
    delete retObj.ValueView;
  }

  return retObj;
}

export const getGlobalPriceSettings = (types = null) => {
  let data = [];
  if (!!types) data = types;
  let fetchResult = postData('/GlobalPriceSetting/GetGlobalPriceSettings', data);

  return fetchResult;
}

export const getGlobalPriceSettingByType = (type) => {
  let data = {
    type: type
  };
  let fetchResult = getData('/GlobalPriceSetting/GetGlobalPriceSettingByType', data);

  return fetchResult;
}

export const saveGlobalPriceSettings = (models) => {
  let data = models;
  let fetchResult = postData('/GlobalPriceSetting/SaveGlobalPriceSettings', data);

  return fetchResult;
}

export const saveGlobalPriceSetting = (model) => {
  let data = model;
  let fetchResult = postData('/GlobalPriceSetting/SaveGlobalPriceSetting', data);

  return fetchResult;
}

export const saveTrainingCategory = (model)=>{
  let data = model;
  let fetchResult = postData('/GlobalPriceSetting/SaveTrainingCategory', data); 
  return fetchResult;
}

export const getTrainingPrices = (courseType)=>{ 
  let fetchResult = getData('/GlobalPriceSetting/GetTrainingPrice', {courseType:courseType}); 
  return fetchResult;
}

export const saveEnglishTrainingPrices = (model)=>{
  let data = model;
  let fetchResult = postData('/GlobalPriceSetting/SaveEnglishTrainingPrices', data); 
  return fetchResult;
}

export const saveNewStudentGuidePrices = (model)=>{
  let data = model;
  let fetchResult = postData('/GlobalPriceSetting/SaveNewStudentGuidePrices', data); 
  return fetchResult;
}

export const saveTrainingPrices = (model)=>{
  let data = model;
  let fetchResult = postData('/GlobalPriceSetting/SaveTrainingPrices', data); 
  return fetchResult;
}

export const getTrainingCategories = (courseType)=>{
  let data = {courseType: courseType};
  let fetchResult = getData('/GlobalPriceSetting/GetTrainingCategories', data); 
  return fetchResult;
}

export const removeTrainingCategory = (id, courseType)=>{
  let data = {id, courseType};
  let fetchResult = getData('/GlobalPriceSetting/RemoveTrainingCategory', data); 
  return fetchResult;
}


export const removeTrainingPrice = (id, courseType)=>{
  let data = {id, courseType};
  let fetchResult = getData('/GlobalPriceSetting/RemoveTrainingPrice', data); 
  return fetchResult;
}

export const saveVipCoursePrice = (data)=>{
  return postData('/GlobalPriceSetting/SaveVipCoursePrice', data); 
}

export const getVipCoursePrices = ()=>{ 
  return getData('/GlobalPriceSetting/GetVipCoursePrices'); 
}


// WEBPACK FOOTER //
// ./src/service/globalPriceSetting.service.js